const CancelToken = window.axios.CancelToken;
let lSource, aSource;

export default {
  searchLives(context, search) {
    if (lSource) {
      lSource.cancel();
    }
    lSource = CancelToken.source();
    return new Promise((resolve, reject) => {
      window.axios
        .get(`/courses/resources?category=lives&search=${search}&limit=1000`, {
          cancelToken: lSource.token
        })
        .then(response => {
          context.commit("setLives", response.data.results);
          resolve();
        })
        .catch(reject);
    });
  },
  searchAudios(context, search) {
    if (aSource) {
      aSource.cancel();
    }
    aSource = CancelToken.source();
    return new Promise((resolve, reject) => {
      window.axios
        .get(`/courses/resources?category=audios&search=${search}&limit=1000`, {
          cancelToken: aSource.token
        })
        .then(response => {
          context.commit("setAudios", response.data.results);
          resolve();
        })
        .catch(reject);
    });
  }
};
